import React, { useState, useEffect } from "react";
import { axiosReq, axiosReq2 } from "../../commons/axiosReq";
import User from "../../assets/icon/NewsIcons/MainAdmin/NewsPerson"
import Search from "../../assets/icon/NewsIcons/MainAdmin/NewsSearch"
import Report from "../../assets/icon/NewsIcons/MainAdmin/NewsReport"
import { MainAdminTables, AddModalWriters, DeleteModalWriters } from "../../components"
import AddModalAdmin from "../../components/MainAdmin/Modals/AddModalAdmin";
import SettingModal from "../../components/MainAdmin/Modals/SettingModal";
import { Link, useNavigate } from "react-router-dom";
import Cookies from 'universal-cookie';
import axios from "axios";
const MainAdminUsers = () => {


    const titleRow = ["نام", "نام خانوادگی", "کدملی", "ادمین", "نام کاربری", "رمز عبور"];
    const adminList = ["علی", "احمدی", "0020163258", "09120760563", "A1324", "A"]
    const [showAddModal, setShowAddModal] = useState(false);

    const [reCheck, setRecheck] = useState(false);
    const [writersList, setWritersList] = useState([]);
    const [data, setData] = useState();
    const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [count, setCount] = useState();
    const [page, setPage] = useState(1);
    const [row, setRow] = useState(10);
    const itemsPerPage = 10;
    let navigate = useNavigate();

    const GetData = async () => {
        const cookies = new Cookies();

        var id = cookies.get('userConnectId');
        const writersData = await axiosReq2("admin/rag_access/rag_systems?user_id=" + id, "get");

        setData(writersData)
    }
    const auth = async () => {
        const cookies = new Cookies();
        var token = cookies.get('token');
        console.log(token)
        console.log(cookies.get('role'))
        if (!token) {
            navigate("/");
        }
        else {
            //     if( cookies.get('role')=="Admin")
            //    {

            GetData()
            //    }


            //     else {
            //         navigate("/admin");

            //     }
        }
    }
    useEffect(() => {

        auth();
    }, [reCheck, search, page, row,]);

    // const StartChat = async () => {
    //     // const dataUser = await axiosReq("user/chatStart", "post",{test:"ok"});
    //     // const dataUser = await axiosReq("user/chatStart", "post",{test:"ok"});
    //     // const dataUser = await axios.post("http://94.182.215.124:9500/chat/start")
    //     const dataUser = await axios.post("http://195.168.1.95:9500/chat/start")
    //     console.log(dataUser)
    //     if (dataUser?.status == 200 || dataUser?.status == 204 || dataUser?.status == 201) {
    //         setRecheck(!reCheck)

    //         //   navigate("/newRequestStep2/" + dataUser?.data?.requestId)
    //         // alert("موفقیت آمیز");
    //         navigate("/chatMain", { state: { id: dataUser?.data?.thread_id, answer: dataUser?.data?.answer } })
    //     }
    //     else {
    //         console.log(dataUser)
    //         // setEroor(dataUser.data);

    //         // setShowErrorModalStep1(true);
    //     }
    // }
    // const StartChatAssistant = async () => {

    //     const dataFile = await axios.post("https://assistant.bordarna.ir/login", {
    //         email: "a.mofid76@yahoo.com",
    //         password: "Aa@123456"
    //     });
    //     console.log(dataFile)
    //     if (dataFile?.status == 200 || dataFile?.status == 204 || dataFile?.status == 201) {

    //         console.log(123)
    //         console.log(dataFile.data)
    //         const cookies = new Cookies();
    //         cookies.set('token2', dataFile.data.access_token, { path: '/' });
    //         cookies.set('name2', "a.mofid76@yahoo.com", { path: '/' });
    //         navigate("/chat");                        // setSnipper(false)
    //     }
    //     else {
    //         console.log(dataFile)

    //     }
    // }
    // const currentItems = writersList.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
    const navtoChatRag = async (item) => {

        navigate("/mainAdmin/chatSessions", { state: { id: item.id,type:"rag" } })
    }
    const navtoChatSimple = async (item) => {

        navigate("/mainAdmin/chatSessions", { state: { id:"",type:"simple" } })
    }
    const navtoChatCreateImage = async (item) => {

        navigate("/chatCreateImage", { state: { id:"",type:"simple" } })
    }
    const navtoGenerateWordCloud = async (item) => {

        navigate("/mainAdmin/wordCloud")
    }
    const navtoGenerateFace = async (item) => {

        navigate("/mainAdmin/faceRecognize")
    }
    return (
        <div>
            <div className="p-[20px] flex justify-between items-center border-b-2 border-borderGray">
                <div className="flex justify-start items-center">
                    <div><User color={'black'} /></div>
                    <p className="font-IRANYekanExtra text-[15px] mr-[15px]">چت بات های متخصص</p>
                </div>
                <div className="flex justify-start items-center">
                    {/* <div className="w-[238px] h-[40px] rounded-[10px] shadow-search-shadow p-[10px] flex justify-between items-center">
                        <input onChange={(e) => setSearch(e.target.value)} className="font-IRANYekanNormal focus:outline-none placeholder-lightGray" type="text" placeholder="جستجو کنید ..." />
                        <button><Search /></button>
                    </div> */}
                    {/* <button className="w-[121px] h-[40px] hoverBgYellow bg-Orange2 shadow-norm-shadow rounded-[10px] mr-[10px] flex justify-center items-center ">
                        <div><Report /></div>
                        <p className="font-IRANYekanBold text-[14px] text-white mr-[7px]">گزارش گیری</p>
                    </button> */}
                    {/* <button onClick={() => setShowAddModal(true)} className="w-[154px] h-[40px] bg-Orange2 shadow-norm-shadow rounded-[10px] mr-[10px] flex justify-center items-center ">
                        <p className="font-IRANYekanLight text-[28px] text-white">+</p>
                        <p className="font-IRANYekanBold text-[14px] text-white mr-[7px]">افزودن ادمین</p>
                    </button> */}
                </div>
            </div>
            <div className="pt-[20px] px-[20px] pb-[280px]">
                <div className="flex flex-wrap items-center justify-evenly">
                    {/* <Link
                        // to={"/chat"}
                        onClick={() => StartChatAssistant()}
                        className="w-[30%] h-[100px]  flex justify-center items-center rounded-3xl  shadow-3xl">
                        <p className="font-IRANYekanBold text-[18px] text-mainColor2 ">(mofid)چت صوتی و متنی</p>
                    </Link>
                    <Link onClick={() => StartChat()} className="w-[30%] h-[100px] flex justify-center items-center rounded-3xl shadow-3xl">
                        <p className="font-IRANYekanBold text-[18px] text-mainColor2 ">دارویاب</p>
                    </Link>
                    <Link to={"/chatDeepSeek"} className="w-[30%] h-[100px] flex justify-center items-center rounded-3xl shadow-3xl">
                        <p className="font-IRANYekanBold text-[18px] text-mainColor2 ">دیپ سیک</p>
                    </Link>*/}
                           <button onClick={() => navtoChatSimple()} className="w-[30%] h-[100px] mt-4 flex justify-center items-center rounded-3xl shadow-3xl">
                                    <p className="font-IRANYekanBold text-[18px] text-mainColor2 ">آزاد</p>
                                </button>
                                  {/* <button onClick={() => navtoChatCreateImage()} className="w-[30%] h-[100px] mt-4 flex justify-center items-center rounded-3xl shadow-3xl">
                                    <p className="font-IRANYekanBold text-[18px] text-mainColor2 ">ساخت عکس</p>
                                </button> 
                                  <button onClick={() => navtoGenerateWordCloud()} className="w-[30%] h-[100px] mt-4 flex justify-center items-center rounded-3xl shadow-3xl">
                                    <p className="font-IRANYekanBold text-[18px] text-mainColor2 ">ابر کلمه</p>
                                </button> 
                                  <button onClick={() => navtoGenerateFace()} className="w-[30%] h-[100px] mt-4 flex justify-center items-center rounded-3xl shadow-3xl">
                                    <p className="font-IRANYekanBold text-[18px] text-mainColor2 "> تشخیص چهره</p>
                                </button>  */}
                    {
                        data?.map((item) => {
                            return (
                                <button onClick={() => navtoChatRag(item)} className="w-[30%] h-[100px] mt-4 flex justify-center items-center rounded-3xl shadow-3xl">
                                    <p className="font-IRANYekanBold text-[18px] text-mainColor2 ">{item.name}</p>
                                </button>
                            )
                        })
                    }
                </div>


            </div>



        </div>
    )
}

export default MainAdminUsers;